import { Spinner } from '@/components/ui/Spinner/Spinner';
import { SessionOverviewPanel } from '../SessionOverviewPanel/SessionOverviewPanel';

export const SessionOverviewLoading = () => (
  <SessionOverviewPanel role='status' aria-live='polite'>
    <Spinner className='size-16 stroke-1' />
  </SessionOverviewPanel>
);
